module.exports = __webpack_public_path__ + "media/site/images/technologies/phoenix-icon-da685fca7020934d31f4525b17961ac2.svg";